// An error as one safe, readable line for a toast (spec §3). It prefers the error's own
// message (ApiError's is the server's sentence), drops anything after a stack frame,
// and NEVER reads `details`, `body` or `response`: those can carry what the user typed,
// credentials included (AI data policy). The fallback is generic rather than
// String(err), which would print "[object Object]" or a whole response.
// Stack frames are cut by SEGMENT, in linear time. The raw text is capped first (a server
// message can be a whole page), then split on line breaks and on runs of 2+ spaces or tabs
// (a stack flattened onto one line); text up to the first segment that looks like a frame
// is kept, with its original separators. Every pattern is anchored with no nested or
// adjacent unbounded quantifiers. A frame flattened with a SINGLE space is not cut: it is
// ambiguous with prose ("failed at app.js:1:1").
const RAW_MAX = 2000;
const SEGMENTS = new RegExp('(\\r\\n|[\\n\\r\\u2028\\u2029]|[ \\t]{2,})');
const V8_START = /^\s*at\s/;
const V8_END = /(?::\d+(?::\d+)?\)?|<anonymous>\)?|\(native\)|\(unknown\))$/;
const GECKO = /^[^\s@]*@\S+:\d+:\d+$/;

const isFrame = (seg) => (V8_START.test(seg) && V8_END.test(seg)) || GECKO.test(seg);

// When the cap cuts the text, its last segment may be the front half of a frame
// ("at save (/srv/s"), which no longer looks like one: drop it if it starts like a frame.
const PARTIAL_FRAME = /^\s*at\s|@/;

function beforeFrame(raw) {
  const parts = raw.slice(0, RAW_MAX).split(SEGMENTS); // text, separator, text, ...
  const cutLast = raw.length > RAW_MAX && parts.length > 1 && PARTIAL_FRAME.test(parts[parts.length - 1]);
  let out = '';
  for (let i = 0; i < parts.length; i += 2) {
    if (isFrame(parts[i]) || (cutLast && i === parts.length - 1)) break;
    out += (i ? parts[i - 1] : '') + parts[i];
  }
  return out;
}

const MAX = 300;
const FALLBACK = 'Unexpected error.';

export function messageOf(err) {
  let text = '';
  if (typeof err === 'string') text = err;
  else if (err !== null && typeof err === 'object' && typeof err.message === 'string') text = err.message;
  text = beforeFrame(text).trim();
  if (!text) return FALLBACK;
  return text.length > MAX ? `${text.slice(0, MAX - 1)}…` : text;
}
